module.exports = __webpack_public_path__ + "static/media/process.e1f5b4f4.svg";